/**
 * @module app.shared
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@autoinject
export class EssFilter {

    @bindable.any({ defaultBindingMode: bindingMode.oneWay })
    public value: any = null;

    @bindable.string({ defaultBindingMode: bindingMode.oneWay })
    public conjunction: string = 'and';

    @bindable.string({ defaultBindingMode: bindingMode.oneWay })
    public label: string = '';

    @bindable.string({ defaultBindingMode: bindingMode.oneWay })
    public op: string = '';

    @bindable.string({ defaultBindingMode: bindingMode.oneTime })
    public type: string = 'search';

    @bindable.string({ defaultBindingMode: bindingMode.oneWay })
    public displayProperty: string = '$display';

    @bindable.booleanAttr({ defaultBindingMode: bindingMode.oneWay })
    public removable: boolean = false;

    @bindable.booleanAttr({ defaultBindingMode: bindingMode.oneWay })
    public visible: boolean = false;

    constructor(private readonly element: Element) { }

    protected hasValue(value: any): boolean {
        if(!value) { return false; }
        if(Array.isArray(value)) { return !!value.find(item => item); }
        return true;
    }

    protected removeFilter(): void {
        if(!this.removable) { return; }

        const event = new CustomEvent('filter-remove', {
            detail: {},
            bubbles: true
        });
        this.element.dispatchEvent(event);

    }

}
